import { APICONFIG } from '@config/api.config';
import { APIService } from '@services/api/common-services';
import { useQuery } from '@tanstack/react-query';
import { IQueryResponse } from '@services/api';
import { ErrorHandler } from '@helper/errorHandler';
import { ISiteLeadOverview } from '@components/SiteLeadOverview';

export const useSiteLeadOverview = (sfid: string): IQueryResponse<ISiteLeadOverview> => {
	const fetchSiteLeadOverview = async (): Promise<ISiteLeadOverview> => {
		try {
			return await APIService.getData<ISiteLeadOverview>(APICONFIG.SITE_LEAD_OVERVIEW + `${sfid}/`);
		} catch (error) {
			ErrorHandler(error);
			throw error;
		}
	};

	const { data, error, isLoading, isPending, isFetching, refetch } = useQuery({
		queryKey: ['siteLeadOverview', sfid],
		queryFn: fetchSiteLeadOverview,
		enabled: !!sfid,
		refetchOnWindowFocus: false,
		retry: false,
	});

	return {
		data,
		error,
		isLoading,
		isPending,
		isFetching,
		refetch,
	};
};
